export default "__VITE_ASSET__Dnxs0j9x__"